module.exports = __webpack_public_path__ + "static/media/homeimg1.6d854df3.svg";